module.exports = __webpack_public_path__ + "img/R6__0628.13784736.jpg";